export const MAX_PIN_SEND_COUNT_PROPERTY_TYPE_ID = "30";
export const MAX_PIN_VERIFY_COUNT_PROPERTY_TYPE_ID = "31";
export const MAX_VERIFICATION_COUNT_PROPERTY_TYPE_ID = "33";
export const HARDCODED_PINS_PROPERTY_TYPE_ID = "39";
export const PIN_TIMEOUT_PROPERTY_TYPE_ID = "74";
export const MOCK_SEND_EMAIL_PIN_PROPERTY_TYPE_ID = "162";

export const PIN_CODE_PROPERTY_TYPE_IDS = [
    MAX_PIN_SEND_COUNT_PROPERTY_TYPE_ID,
    MAX_PIN_VERIFY_COUNT_PROPERTY_TYPE_ID,
    HARDCODED_PINS_PROPERTY_TYPE_ID,
    PIN_TIMEOUT_PROPERTY_TYPE_ID,
    MOCK_SEND_EMAIL_PIN_PROPERTY_TYPE_ID
];

export const DEFAULT_PIN_SEND_COUNT = "2";
export const DEFAULT_VERIFICATION_COUNT = "3";
export const DEFAULT_PIN_TIMEOUT = "600";
export const PIN_CODE_LENGTH = 6;